import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ICityDetails } from 'src/app/models/ICityDetails';
import { IStates } from 'src/app/models/IStates';
import { DialogData } from 'src/app/preview-file-or-image/preview-file-or-image.component';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';

@Component({
  selector: 'app-dm-provider-search',
  templateUrl: './dm-provider-search.component.html',
  styleUrls: ['./dm-provider-search.component.css']
})
export class DmProviderSearchComponent implements OnInit {
  displayedColumns: string[] = ['Prefix','LastName', 'FirstName','MiddleName','Suffix','BusinessName','Specialty', 'AddressLine1','AddressLine2', 'City', 'StateProvince', 'PostalCode','PrimaryTelephone', 'DirectAddress'];
  public show: boolean = false;
  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }

  providerform: FormGroup;
  submitted = false;
  public lstStates: IStates[];
  public selectedStatelst: IStates[];
  firstName: string = "";
  lastName: string = "";
  clinicName: string = "";
  specialty: string = "";
  stateCode: string = "";
  zipCode: string = "";
  cityName: string = "";
  directAddress: string = "";
  providersData: any[] = [];
  dataSource1 = new MatTableDataSource(this.providersData);

  //Paginator Variables Decl
  lstProviders = [];
  pageNo: any = 1;  
  pageNumber: boolean[] = [];  
  searchTermMain: any = ''; 
  pageField = [];  
  exactPageList: any;  
  paginationData: number; 
  providersPerPage: any = 10; 
  totalproviders: any;  
  totalprovidersCount: any;

  constructor(
    private formBuilder: FormBuilder, public dialogRef: MatDialogRef<DmProviderSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private rxService: RxService,
     private spinner: NgxSpinnerService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

    this.rxService.getAllStates().subscribe(data => {
      this.lstStates = data;
      this.statesfilter();
    });

    this.pageNumber[0] = true;  
    this.rxService.temppage = 0;

    this.providerform = this.formBuilder.group({
      firstName: ['',],
      lastName: ['',],
      clinicName: ['',],
      specialty: ['',],
      state: ['',],
      zip: ['',],
      city: ['',],
      directAddress: ['',],
    });
  }

  get f() { return this.providerform.controls; }

  onSubmit() {
    this.submitted = true;
  }
  searchresult: string = "";
  public stateCodeMain: string = "";

  onProvidersearchClick() {
    this.firstName = this.providerform.value.firstName;
    this.lastName = this.providerform.value.lastName;
    this.clinicName=this.providerform.value.clinicName;
    this.specialty=this.providerform.value.specialty;
    this.stateCode = this.stateCodeMain;
    this.zipCode = this.providerform.value.zip;
    this.cityName = this.providerform.value.city;
    this.directAddress=this.providerform.value.directAddress;
    this.pageNumber = [];
    this.rxService.temppage = 0; 
    this.pageNumber[0] = true;  
    this.pageNo = 1;   
    //this.cityName = this.autocityId;
     
    this.rxService.GetAllDownloadedProvidersTService(this.firstName, this.lastName,
      this.clinicName,this.specialty,this.directAddress, this.stateCode, this.zipCode, this.cityName,this.pageNo).subscribe(data => {
      this.providersData = data;
      if (this.providersData.length > 0) {
        this.searchresult = "";
        this.getCountAllProviders();
      }
      else {
        this.searchresult = "No search results found.";
      }
      this.dataSource1.data = this.providersData;
    });
  }

  //Service side pagination
  //Clearing Performance issue

  getCountAllProviders() {
    if (this.lastName || this.firstName ||this.clinicName ||this.specialty ||this.directAddress || this.stateCode || this.zipCode || this.cityName) {
      this.rxService.GetAllDownloadedProvidersCountTService(this.firstName,this.lastName,this.clinicName,this.specialty,this.directAddress,this.stateCode, this.zipCode, this.cityName).subscribe(data => {
        this.totalprovidersCount = data;
        this.totalNoOfPages();
        //this.spinner.hide();
      },
        (err: any) => {
          console.log(err);
          //this.spinner.hide();
        });
    }
    else {
      this.searchresult = "Search with required data";
      //this.spinner.hide();
    }
  }
  //Method For Pagination  

  totalNoOfPages() {
     
    this.pageField = [];
    this.paginationData = Number(this.totalprovidersCount / this.providersPerPage);
    let tempPageData = this.paginationData.toFixed();
    if (Number(tempPageData) < this.paginationData) {
      this.exactPageList = Number(tempPageData) + 1;
      this.rxService.exactPageList = this.exactPageList;
    } else {
      this.exactPageList = Number(tempPageData);
      this.rxService.exactPageList = this.exactPageList
    }
    this.rxService.pageOnLoad();
    this.pageField = this.rxService.pageField;
  }
  showPharmacyByPageNumber(page, i) {
    this.lstProviders = [];
    this.pageNumber = [];
    this.pageNumber[i] = true;
    this.pageNo = page;
    this.rxService.temppage = 0;
    this.rxService.GetAllDownloadedProvidersTService(this.firstName, this.lastName,
      this.clinicName,this.specialty,this.directAddress, this.stateCode, this.zipCode, this.cityName,this.pageNo).subscribe(data => {
    this.providersData = data;
    if (this.providersData.length > 0) {
      this.searchresult = "";
      this.getCountAllProviders();
    }
    else {
      this.searchresult = "No search results found.";
    }
    this.dataSource1.data = this.providersData;
  });

  }




  public lstCity: ICityDetails[];
  stateSelectionChange(Value) {
    //var stateId = Value.source.value;
    this.stateCodeMain =this.providerform.value.state;
    var stateId = Value;
    this.selectedStatelst = this.lstStates.filter(a => a.stateId == stateId);
    if (this.selectedStatelst.length > 0) {
      this.stateCodeMain = this.selectedStatelst[0].stateCode;
    }

    this.rxService.getAllCitys(stateId).subscribe(data => {
      this.lstCity = data;
      this.cityfilter();
    });
  }

  pharmacyAddress: string = "";
  checkfunction(element) {
    this.dialogRef.close(element);
  }

  public stateId: string;
  stateOptions: Observable<IStates[]>;

  public autocityId: string;
  cityOptions: Observable<ICityDetails[]>;
  statesfilter() {
    this.stateOptions = this.providerform.get('state')!.valueChanges.pipe(
      startWith(""),
      map(value => this._states(value))
    );
  }
  private _states(value: string): IStates[] {
    const filterValue = value.toString().toLowerCase();
    return this.lstStates.filter(option => option.stateCode.toLowerCase().indexOf(filterValue) === 0);
  }

  cityfilter() {
    this.cityOptions = this.providerform.get('city')!.valueChanges.pipe(
      startWith(""),
      map(value => this._city(value))
    );
  }
  private _city(value: string): ICityDetails[] {
    const filterValue = value.toString().toLowerCase();
    return this.lstCity.filter(option => option.cityName.toLowerCase().indexOf(filterValue) === 0);
  }

  onSelectionChanged(event, type: string) {
    let autoval = event;
    if (type === "States") {
      let statelist = this.lstStates.filter(x => x.stateCode === autoval);
      if (statelist.length != 0) {
        this.stateId = statelist[0].stateId.toString();
        this.stateSelectionChange(this.stateId);
      } else {
        this.stateId = "";
        this.stateSelectionChange(this.stateId);
      }
    } else if (type === "City") {
      let citylist = this.lstCity.filter(x => x.cityName === autoval);
      if (citylist.length != 0) {
        this.autocityId = citylist[0].cityName.toString();
      } else {
        this.autocityId = "";
      }
    }
  }
}
